import { Link } from 'react-router-dom';
import type { Actor } from '@/types/content';

interface ActorCardProps {
  actor: Actor;
}

export default function ActorCard({ actor }: ActorCardProps) {
  return (
    <Link
      to={`/actor/${actor.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={actor.avatar}
          alt={`演员 ${actor.name} 饰演 ${actor.role} 剧照头像`}
          title={`${actor.name} 女友的妈妈 演员资料`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute bottom-2 left-2 right-2 px-2 py-1 rounded-md bg-primary-950/75 text-background-50 text-[11px] text-center backdrop-blur-sm">
          {actor.role}
        </span>
      </div>
      <div className="p-3 text-center">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
          {actor.name}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{actor.birthPlace}</p>
      </div>
    </Link>
  );
}